/**
 * @file drag-n-drop.component.tsx
 * @description Компонент реализует загрузку файла при перетаскивании мышкой на области. Используется библиотека react-dropzone.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { useDropzone } from 'react-dropzone';
import { Text } from '@consta/uikit/Text';
import cn from 'classnames';
import { ReactNode } from 'react';

/**
 * Props для компонента DragNDropZone
 */
interface IDragNDropZoneProps {
    /** Обработчик изменения при добавлении файлов */
    onChange: (files: File[]) => void;
    /** Дочерние элементы */
    children: ReactNode;
    /** CSS класс для дополнительной стилизации */
    className?: string;
}

export const DragNDropZone = ({ onChange, children, className }: IDragNDropZoneProps) => {
    const { getRootProps, isDragActive } = useDropzone({
        noClick: true, // отключаем click-to-open
        noKeyboard: true, // и keyboard-действие
        onDrop: onChange
    });

    return (
        <div {...getRootProps()} className={cn('relative', className)}>
            {children}

            {isDragActive && (
                <div
                    className="
                  fixed inset-0 z-50 flex items-center justify-center
                  bg-[#0078d2] bg-opacity-30
                "
                >
                    <div
                        className="
                    bg-white p-6 rounded-lg shadow-lg text-center
                  "
                    >
                        <Text>Отпустите файлы, чтобы загрузить</Text>
                    </div>
                </div>
            )}
        </div>
    );
};
